import * as React from 'react'

import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded'

import { useSupport } from 'components/hooks/use-support'
import { I18n, useTranslation } from 'components/hooks/use-translation'
import IconButton from 'components/atomic/atoms/icon-button'

const SupportIcon = () => {
    const { t }: I18n = useTranslation()
    const { toggleChatWidget, isChatWidgetVisible } = useSupport()

    return (
        <IconButton
            aria-label="Support chat"
            variant="outlined"
            tooltip={isChatWidgetVisible ? t('common:header.closeSupportChat') : t('common:header.openSupportChat')}
            onClick={() => toggleChatWidget()}>
            <ContactSupportRoundedIcon fontSize="small" />
        </IconButton>
    )
}

export default SupportIcon
